<template>
  <div style="position: relative;margin: 12px 12px;">
    <div class="item-title">
      {{ item && item.title ? item.title : '' }}
      <label
        class="item-staus"
        v-if="item && item.isoriginal && String(item.isoriginal) !== '0'"
      >原创</label>
    </div>
    <div
      class="item-content-time"
      style="color: #bbb;margin-bottom:6px;"
      v-if="item && item.isoriginal && String(item.isoriginal) === '0' && item.source"
    >本文章取自{{ item.source }}，若涉及侵权请联系版主删帖</div>
    <div class="item-content-time" style="margin-bottom:6px;">发布时间：{{ releaseTime }}</div>
    <div class="item-like-info">
      <i
        class="iconfont icon-heart"
        :style="{verticalAlign: 'middle',marginRight: '6px', color: isLike ? '#f00' : '#1a1a1a'}"
        @click="toLike"
      />
      {{ item && item.likenum ? item.likenum: 0 }}
      <i
        class="iconfont icon-message"
        :style="{verticalAlign: 'middle', marginLeft: '12px', marginRight: '6px'}"
      />
      {{ item && item.commentsnum ?item.commentsnum :0 }}
      <i 
        class="iconfont icon-shoucang"
        :style="{verticalAlign: 'middle', marginLeft: '12px', marginRight: '6px', fontSize: '20px', color: isCollect ? '#f00' : '#1a1a1a'}"
        @click="toCollect"
      />
      {{ item && item.collectnum ? item.collectnum : 0 }}
    </div>
    <div v-html="item.main_text" style="margin-top: 12px;"></div>
  </div>
</template>
<script>
import xyAPI from '@/api/xyAPI'
import loadData from '@/https/loadData'
import xy_config from '@/config/xy_config'
import moment from 'moment'
export default {
  name: 'ArticleDetailContent',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isLike: false,
      isCollect: false
    }
  },
  computed: {
    releaseTime () {
      return this.item && this.item.release_time ? moment(this.item.release_time).format('YYYY-MM-DD') : ''
    }
  },
  mounted () {
    this.getLikeInfo()
    this.getUserIsClickCollectArticle()
  },
  methods: {
    async toLike () {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        _that.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
        return
      }
      try {
        const res = await loadData(xyAPI.userClickLikeArticle, { articleid: _that.item.id })
        if (res && String(res.code) === '0') {
          _that.$message('操作成功')
          _that.getLikeInfo()
          _that.$emit('refreshData')
        } else {
          _that.$message(res && res.msg ? res.msg : '操作失败')
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    async toCollect() {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        _that.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
        return
      }
      try {
        const res = await loadData(xyAPI.userClickCollectArticle, { articleid: _that.item.id })
        if (res && String(res.code) === '0') {
          _that.$message('操作成功')
          _that.getUserIsClickCollectArticle()
          _that.$emit('refreshData')
        } else {
          _that.$message(res && res.msg ? res.msg : '操作失败')
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    async getLikeInfo () {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        return
      }
      try {
        const res = await loadData(xyAPI.userIsClickLikeArticle, { articleid: _that.item.id })
        if (res && String(res.code) === '0') {
          _that.isLike = true
        } else {
          _that.isLike = false
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    async getUserIsClickCollectArticle () {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        return
      }
      try {
        const res = await loadData(xyAPI.userIsClickCollectArticle, { articleid: _that.item.id })
        if (res && String(res.code) === '0') {
          _that.isCollect = true
        } else {
          _that.isCollect = false
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    }
  }
}
</script>
<style lang="less" scoped>
.item-content-time {
  font-size: 12px;
  color: #999;
  line-height: 15px;
}
.item-like-info {
  font-size: 16px;
  line-height: 24px;
}
.item-title {
  font-size: 22px;
  color: #111;
  line-height: 28px;
  margin-bottom: 6px;
  font-weight: bold;
  .item-staus {
    padding: 0px 6px;
    line-height: 18px;
    font-size: 14px;
    background: #f00;
    color: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 8px;
    margin-left: 12px;
    font-weight: 600;
  }
}
</style>